import create from 'zustand';
import api from '@/utils/api';
import { ContentType } from '@/lib/types';

interface Type extends ContentType {
  workspace_content_type_id: number;
  workspace_content_type_reference_id: string;
}
interface ContentTypesStore {
  contentTypes: Type[];
  showAlert: boolean;
  error: string | null;
  loadContentTypes: (workspaceId: string) => Promise<void>;
}

const useContentTypesStore = create<ContentTypesStore>((set) => ({
  contentTypes: [],
  showAlert: false,
  error: null,
  loadContentTypes: async (workspaceId: string) => {
    try {
      set({ showAlert: false, error: null });
      const response = await api.get(`content-types/workspace/${workspaceId}`);
      const types = response.data.data.sort((a: Type, b: Type) =>
        a.name.localeCompare(b.name),
      ) as Type[];
      set({
        contentTypes: types,
        showAlert: types.length === 0 ? true : false,
      });
    } catch (error: any) {
      set({
        error: error.response?.data?.error || 'Failed to load content libraries',
        showAlert: false,
      });
    }
  },
}));

export default useContentTypesStore;
